import * as React from "react";
import { action } from "mobx";
import { inject, observer } from "mobx-react";
import { Switch, Route, withRouter } from "react-router-dom";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import PrivateRoute from "./components/PrivateRoute";

@inject ("commonStore")
@(withRouter as any)
@observer
export class App extends React.Component<any> {

	componentDidMount() {
		window.addEventListener("resize", this.handleResize);
		this.handleResize();
	}

	componentWillUnmount() {
	 	window.addEventListener("resize", null);
	}

	@action.bound handleResize() {
        this.props.commonStore.setIsMobile(window.innerWidth);
    }

	render() {

		return (
			
			<div className="app-router">         
				<Switch>
					<Route path="/login" component={Login} />
					<PrivateRoute path="/" component={Home} />
				</Switch>				
			</div>        
		);
	}
}